<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <v-autocomplete
      v-model="innerValue"
      :items="times"
      v-on="$listeners"
      v-bind="$attrs"
      item-text="codeName"
      item-value="codeValue"
      :label="label"
      :filter="timeFilter"
      :error-messages="errors"
    ></v-autocomplete>
    <!-- <v-menu
      ref="menu1"
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="innerValue"
          :append-icon="prependIcon"
          v-on="on"
          v-bind="$attrs"
          :label="label"
          :error-messages="errors"
          autocomplete="off"
        ></v-text-field>
      </template>
      <v-time-picker
        v-model="innerValue"
        format="24hr"
        :use-seconds="useSeconds"
      ></v-time-picker>
    </v-menu> -->
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    prependIcon: {
      type: String,
      default: "mdi-clock-time-four-outline",
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
    label: String,
    // useSeconds: Boolean,
    format: {
      type: String,
      default: "24hr", // 24hr, ampm
    },
    // 개선 작업 20201209 kimjungwon
    timeTick: {
      // 리스트 분 단위
      type: [Number, String],
      default: 15,
    },
  },
  computed: {
    times() {
      // prop 설정의 단위로 계산.
      let hour = 0;
      let min = 0;
      let timeTick = parseInt(this.timeTick);
      let times = [];
      while (hour < 24) {
        while (min < 60) {

          let hourStr = (this.format=="ampm" && hour > 12 ? hour-12 : hour).toString().padStart(2, "0");
          let minStr = min.toString().padStart(2, "0");
          let ampmStr = "";
          let codeName = hourStr + ":" + minStr;
          if(this.format == "ampm"){
            // if(hour < 12){
            //   ampmStr = this.$t("common.lbl.am_hour");
            // }else {
            //   ampmStr = this.$t("common.lbl.pm_hour");
            // }
            ampmStr = hour < 12 ? this.$t("common.lbl.am_hour") : this.$t("common.lbl.pm_hour");

            switch (this.$i18n.locale) {
              case "ko":
                codeName = ampmStr + " " + codeName;
                break;
              case "ja":
                codeName = ampmStr + codeName;
                break;
              default:
                codeName = codeName + " " + ampmStr;
                break;
            }
          }

          let time = {
            codeName: codeName,
            codeValue: `${hour.toString().padStart(2, "0")}:${minStr}`,
          };
          times.push(time);
          min += timeTick;
        }
        hour += 1;
        min = 0;
      }
      //24:00
      return times;
    },
  },
  data() {
    return {
      // menu1: false,
      innerValue: null,
    };
  },
  methods: {
    timeFilter: (item, queryText, itemText) => {
        return (itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        || item.codeValue.replace(":","").toLocaleLowerCase().indexOf(queryText.replace(":","").toLocaleLowerCase()) > -1)
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      // this.dateFormatted = this.formatDate(this.innerValue);
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style>
</style>